module.exports = __webpack_public_path__ + "static/media/Microbrew-Two-3D-Regular.db2b874b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Microbrew-Two-3D-Regular.woff2
// module id = 1690
// module chunks = 49